<div class="center-full-screen">
  <div class="component-container" [class.off]="ctrl === 'off'" [style.background-image]="'url('+broadcast?.config?.bigLogoUrl+')'">
    <div class="component-wrapper">
      <div class="team-section home"
           [style.background-color]="utilService.getTeamBgrByGuid(broadcast.config.homeConfig.id, broadcast)">
        <div class="logo">
          <img *ngIf="!utilService.hideTeamLogos(broadcast)" src="{{ broadcast.config.homeConfig.logoUrl }}">
          <span class="team-code" *ngIf="utilService.hideTeamLogos(broadcast)">{{ broadcast.config.homeConfig.shortName }}</span>
        </div>
        <div class="name">
          {{ broadcast.config.homeConfig.fullName }}
        </div>
      </div>
      <div class="team-section away"
           [style.background-color]="utilService.getTeamBgrByGuid(broadcast.config.awayConfig.id, broadcast)">
        <div class="logo">
          <img *ngIf="!utilService.hideTeamLogos(broadcast)" src="{{ broadcast.config.awayConfig.logoUrl }}">
          <span class="team-code" *ngIf="utilService.hideTeamLogos(broadcast)">{{ broadcast.config.awayConfig.shortName }}</span>
        </div>
        <div class="name">
          {{ broadcast.config.awayConfig.fullName}}
        </div>
      </div>
    </div>
  </div>
</div>
